import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ConversationSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const ConversationSearchBar = ({ value, onChange }: ConversationSearchBarProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-[#54656F]" />
      <Input
        placeholder="Pesquisar conversas"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10 bg-white text-[#111B21] placeholder:text-[#667781]"
      />
    </div>
  );
};